import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-dispatcher-v1',
  templateUrl: './dispatcher-v1.component.html',
  styleUrls: ['./dispatcher-v1.component.scss']
})

export class DispatcherV1Component implements OnInit{
  @ViewChild('menu', { static: false }) menuRef!: ElementRef;
  isClicked : boolean = false;
  presentComponent:number = 1;
  features = [
    "Dashboard to see your bookings, equipment information and all past transactions",
    "Parking options at secure top-tier lots",
    "Quick & easy access to lot details & booking information",
    "Seamless booking of multiple spots for your group"
];
  ngOnInit(): void {
    localStorage.removeItem('isEmailVerified');
  }

@HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const clickedInside = this.menuRef?.nativeElement?.contains(event.target);
    if (!clickedInside) {
      this.isClicked = false;
    }
  }
}
